// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2M4Ho","messages":"Chat_messages__2mg_x","dateDivider":"Chat_dateDivider__1rIAA"};